import React, { useState, useEffect } from "react";

const SearchBar = ({ language, allProducts = [], onResults, searchQuery, setSearchQuery }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!searchQuery.trim()) {
      onResults(allProducts);
      return;
    }

    const delayDebounce = setTimeout(() => {
      handleSmartSearch(searchQuery.trim());
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, allProducts]);

  const handleSmartSearch = async (query) => {
    setLoading(true);
    try {
      const productList = allProducts.map((p, i) => {
        const name =
          typeof p.Name === "object"
            ? `FR: ${p.Name.fr || ""} | AR: ${p.Name.ar || ""}`
            : p.Name || "";
        const desc =
          typeof p.description === "object"
            ? p.description.fr || p.description.ar || ""
            : p.description || "";
        const slug =
          typeof p.slug === "object"
            ? p.slug.fr || p.slug.ar || ""
            : p.slug || "";
        return `${i}. Name: ${name} | Description: ${desc} | Tags: ${slug}`;
      }).join("\n");

      const prompt = `
Tu es un assistant de recherche pour une boutique de cosmétiques bio marocaine appelée Rehab Bio.

L'utilisateur cherche: "${query}"

Voici la liste des produits disponibles:
${productList}

Retourne UNIQUEMENT un tableau JSON des indices (index numbers) des produits qui correspondent à la recherche de l'utilisateur, même de façon indirecte (par problème, symptôme, ingrédient, ou bénéfice).
Par exemple si l'utilisateur écrit "anti chute" ou "cheveux qui tombent" ou "تساقط الشعر", retourne les produits liés à la chute des cheveux.

Réponds UNIQUEMENT avec un tableau JSON comme: [0, 3, 7]
Si aucun produit ne correspond, retourne: []
`;

      const response = await fetch("https://api.anthropic.com/v1/messages", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: 1000,
          messages: [{ role: "user", content: prompt }],
        }),
      });

      const data = await response.json();
      const text = data.content?.map((c) => c.text || "").join("") || "[]";
      const match = text.match(/\[[\d,\s]*\]/);
      const indices = match ? JSON.parse(match[0]) : [];
      const matched = indices
        .filter((i) => i >= 0 && i < allProducts.length)
        .map((i) => allProducts[i]);

      onResults(matched);
    } catch (err) {
      console.error("Smart search error:", err);
      const q = query.toLowerCase();
      const filtered = allProducts.filter((p) => {
        const name = p.Name;
        if (typeof name === "object") {
          return (
            (name.fr || "").toLowerCase().includes(q) ||
            (name.ar || "").toLowerCase().includes(q)
          );
        }
        return (name || "").toLowerCase().includes(q);
      });
      onResults(filtered);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: "1.5rem 0 0.5rem",
      width: "100%",
      gap: "8px",
    }}>
      <style>{`@keyframes sb-spin { to { transform: rotate(360deg); } }`}</style>

      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        background: "#fff",
        border: "2px solid #4e7662",
        borderRadius: "50px",
        padding: "8px 20px",
        width: "100%",
        maxWidth: "480px",
        boxShadow: "0 2px 10px rgba(78,118,98,0.1)",
      }}>
        {loading ? (
          <div style={{
            width: "16px",
            height: "16px",
            border: "2px solid #d1d5db",
            borderTopColor: "#4e7662",
            borderRadius: "50%",
            animation: "sb-spin 0.7s linear infinite",
            flexShrink: 0,
          }} />
        ) : (
          <i className="bi bi-search" style={{ color: "#4e7662", fontSize: "16px", flexShrink: 0 }} />
        )}

        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={
            language === "ar"
              ? "ابحث بمشكلتك: تساقط الشعر، حب الشباب..."
              : "Recherchez: anti chute, acné, hydratation..."
          }
          dir={language === "ar" ? "rtl" : "ltr"}
          style={{
            border: "none",
            outline: "none",
            width: "100%",
            fontSize: "15px",
            color: "#1f2937",
            background: "transparent",
            fontFamily: "inherit",
          }}
        />

        {searchQuery && (
          <button
            onClick={() => {
              setSearchQuery("");
              onResults(allProducts);
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#9ca3af",
              fontSize: "20px",
              lineHeight: 1,
              padding: 0,
              flexShrink: 0,
            }}
          >
            ×
          </button>
        )}
      </div>

      <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0, textAlign: "center" }}>
        {language === "ar"
          ? "💡 يمكنك وصف مشكلتك بدل اسم المنتج"
          : "💡 Vous pouvez décrire votre problème plutôt que le nom du produit"}
      </p>
    </div>
  );
};

export default SearchBar;